import { TItem } from '@/components/GridBoards/types';
import APP_ITEMS from '../items/apps';
import { $fm } from '@/Intl';
import { isInSider } from '../doWithSider';

const createApp = (
  props: {
    className: string;
    x?: number;
    y?: number;
  },
  siderbounds: LayoutBoxSiderbounds,
): TItem => {
  const id = props.className as keyof typeof APP_ITEMS;
  const title = APP_ITEMS[id].title;
  const img = APP_ITEMS[id].img;
  const imgTr = APP_ITEMS[id].imgTr;
  return {
    id: id,
    x: props.x ?? -1,
    y: props.y ?? -1,
    w: 1,
    h: 1,
    isApp: true,
    repeat: false,
    render: (item, placeholder, dragging) => {
      const _x = placeholder?.x ?? item.x;
      const _y = placeholder?.y ?? item.y;
      return (
        <div className='layout-app'>
          {isInSider(_x, _y, siderbounds) ? (
            <div className='tr'>
              <img src={imgTr} alt={title} draggable={false} />
            </div>
          ) : (
            <div className='not-tr'>
              <img src={img} alt={title} draggable={false} />
              <span>{$fm(title)}</span>
            </div>
          )}
        </div>
      );
    },
    renderPick: () => {
      return (
        <div className='layout-pick-app'>
          <img src={img} alt={title} draggable={false} />
          <span>
            {$fm(title)}
            <br />
            (1 × 1)
          </span>
        </div>
      );
    },
  };
};
export default createApp;
